<template>
    <div class="container">
        <form class="my-5" role="form" id="paycometPaymentForm" action="javascript:void(0);" @submit.prevent="getPayToken" method="POST">
            <input id="jetID" type="hidden" data-paycomet="jetID" :value="jet_id"/>

            <!-- Nombre del titular  -->
            <div class="form-group mb-3">
                <div class="input-group">
                    <div class="form-group w-100">
                        <label for="username">{{ $t('formulario_pago.titular') }}</label>
                        <input type="text" id="inputNombre" class="form-control bg-white" name="username" data-paycomet="cardHolderName" :placeholder="$t('formulario_pago.titular')" required />
                    </div>
                </div>
            </div>

            <div class="row">
                <!-- Nº de tarjeta  -->
                <div class="col-sm-6">
                    <div class="form-group">
                        <label for="paycomet-pan">{{ $t('formulario_pago.n_tarjeta') }}</label>
                        <div class="form-control">
                            <div id="paycomet-pan" style="padding:0px; height:36px;"></div>
                            <input
                                id="inputNTarjeta"
                                paycomet-style="width: 100%; height: 21px; font-size:14px; padding: 7px 0px 7px 7px; outline:none !important;"
                                paycomet-name="pan"
                                paycomet-placeholder="Introduce tu tarjeta..."
                            />
                        </div>
                    </div>
                </div>

                <!-- CVC / CVV  -->
                <div class="col-sm-2">
                    <div class="form-group">
                        <label for="paycomet-cvc2">CVC/CVV</label>
                        <div class="form-control">
                            <div id="paycomet-cvc2" style="height: 36px; padding:0px;"></div>
                            <input
                                paycomet-name="cvc2"
                                paycomet-style="border:0px; width: 100%; height: 21px; padding-top: 7px ;font-size:12px; padding-left:7px;"
                                paycomet-placeholder="CVV/CVC"
                            />
                        </div>
                    </div>
                </div>

                <!-- Fecha de expiración  -->
                <div class="col-sm-4">
                    <div class="form-group">
                        <label for="fechaCaducidad">{{ $t('formulario_pago.fecha_expiracion') }}</label>
                        <div class="form-inline">
                            <select id="mesCaducidad" class="form-control" style="width:45%;" data-paycomet="dateMonth">
                                <option selected disabled>MM</option>
                                <option value="01">01</option>
                                <option value="02">02</option>
                                <option value="03">03</option>
                                <option value="04">04</option>
                                <option value="05">05</option>
                                <option value="06">06</option>
                                <option value="07">07</option>
                                <option value="08">08</option>
                                <option value="09">09</option>
                                <option value="10">10</option>
                                <option value="11">11</option>
                                <option value="12">12</option>
                            </select>
                            <span style="width:10%; text-align: center; padding-bottom: 5px;"> / </span>
                            <select id="anoCaducidad" class="form-control" style="width:45%;" data-paycomet="dateYear">
                                <option selected disabled>AA</option>
                                <template v-for="anoCaducidad in anosCaducidad">
                                    <option :key="anoCaducidad" :value="anoCaducidad.toString().slice(-2)">{{ anoCaducidad }}</option>
                                </template>
                            </select>
                        </div>
                    </div>
                </div>
                <b-col sm="12" md="6">
                    <button class="button large effect-button btn-block mt-3" id="confirmar-tarjeta">
                        <span>{{ $t('formulario_pago.confirmar') }}</span>
                    </button>
                </b-col>
                <b-col sm="12" md="6">
                    <button type="button" class="button large effect-button btn-block mt-3" @click="cancelarCompra()">
                        <span>{{ $t('formulario_pago.cancelar') }}</span>
                    </button>
                </b-col>
            </div>
            <div class="error-paycomet" id="paymentErrorMsg"></div>
        </form>
    </div>
</template>

<script>
    export default {
        props: ['jet_id'],
        mounted() {
            let paycometScript = document.createElement('script');
            paycometScript.setAttribute('src', 'https://api.paycomet.com/gateway/paycomet.jetiframe.js?lang=es');
            document.head.appendChild(paycometScript);
        },
        computed: {
            anosCaducidad() {
                let arrAnos = [];
                let anoActual = new Date().getFullYear();

                for (let i = 0; i < 10; i++) {
                    arrAnos.push(anoActual + i);
                }
                return arrAnos
            }
        },
        methods: {
            getPayToken() {
                this.waitForElm('#paycometPaymentForm input[name=paytpvToken]').then(elm => {
                    this.$emit('payToken', elm.value);
                })
            },
            waitForElm(selector) {
                return new Promise(resolve => {
                    if (document.querySelector(selector)) {
                        return resolve(document.querySelector(selector));
                    }

                    const observer = new MutationObserver(mutations => {
                        if (document.querySelector(selector)) {
                            resolve(document.querySelector(selector));
                            observer.disconnect();
                        }
                    });

                    observer.observe(document.body, {
                        childList: true,
                        subtree: true
                    });
                });
            },
            cancelarCompra() {
                window.location.reload();
            }
        }
    }
</script>

<style scoped>
.form-control {
    height: 50px;
}

.large {
    font-size: 16px;
    padding: 15px 35px;
    margin-right: 20px;
    min-width: 155px;
}

.form-inline {
    display: flex;
    align-items: first baseline;
}

.error-paycomet {
    color: #D8000C;
    background-color: #FFBABA;
    padding: 3px;
    border-radius: 6px;
    margin-top: 7px;
    padding-left: 15px;
}

.error-paycomet:empty {
    display: none;
}
</style>
